import {
    Autocomplete,
    Chip,
    Stack,
    TextField,
    Typography,
} from '@mui/material';

import { useUnityIds } from '../hooks/useUnityIds';

export interface DistrictInputProps {
    value: string;
    onChange: (value: string) => void;
}

export const DistrictInput = ({ value, onChange }: DistrictInputProps) => {
    const { data, isLoading } = useUnityIds();

    const selectedDistrict =
        value && data
            ? data.districts.find((district) => district.id === value)
            : null;
    const isUnknown = selectedDistrict === undefined;
    const isNonFree = selectedDistrict ? !selectedDistrict.isFree : false;
    const hasWarning = isUnknown || isNonFree;
    const warningMessage = isUnknown
        ? `'${value}' is an unknown district id.`
        : isNonFree
          ? `'${value}' is a non-free district.`
          : undefined;

    return (
        <Autocomplete
            value={value}
            onChange={(_, value) => {
                if (typeof value === 'string') {
                    onChange(value);
                } else if (value) {
                    onChange(value.id);
                } else {
                    onChange('');
                }
            }}
            freeSolo
            autoSelect
            loading={isLoading}
            options={
                data?.districts.toSorted((a, b) => {
                    return Number(b.isFree) - Number(a.isFree);
                }) ?? []
            }
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="District"
                    color={hasWarning ? 'warning' : undefined}
                    error={hasWarning}
                    helperText={warningMessage}
                    slotProps={{
                        ...params.slotProps,
                        input: {
                            ...params.slotProps?.input,
                            type: 'search',
                        },
                    }}
                />
            )}
            renderOption={(props, option) => {
                return (
                    <li {...props} key={option.id}>
                        <Stack direction="row" spacing={1}>
                            {option.isFree ? (
                                <Chip color="success" label="Free" />
                            ) : (
                                <Chip color="warning" label="Paid" />
                            )}
                            <Typography>{option.id}</Typography>
                        </Stack>
                    </li>
                );
            }}
            getOptionLabel={(option) =>
                typeof option === 'string' ? option : option.id
            }
        />
    );
};
